module.exports = __webpack_public_path__ + "static/media/telematics_640_color.8d2024bd.png";